const icon = (
	/*HEADING ICON FROM FONTAWESOME*/ <svg
		xmlns="http://www.w3.org/2000/svg"
		height="20"
		width="20"
		viewBox="0, 0, 512,  512"
	>
		<path
			fill="#f63d3d"
			d="M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
		></path>
	</svg>
);

/**H1, H2, H3, H4, H5 and H6 icons from GridIcons, available under GPL v2 */
export const h1Icon = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<rect x="0" fill="none" width="24" height="24" />

		<path d="M11 7h2v10h-2v-4H7v4H5V7h2v4h4V7zm6.57 0A4.742 4.742 0 0115 9v1h2v7h2V7h-1.43z" />
	</svg>
);

export const h2Icon = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<rect x="0" fill="none" width="24" height="24" />

		<path d="M9 7h2v10H9v-4H5v4H3V7h2v4h4V7zm8 8c.51-.41.6-.62 1.06-1.05.437-.4.848-.828 1.23-1.28a6.4 6.4 0 00.85-1.28c.199-.39.305-.822.31-1.26a3.007 3.007 0 00-.27-1.28 2.902 2.902 0 00-.76-1 3.485 3.485 0 00-1.17-.63 4.766 4.766 0 00-1.5-.22c-.359 0-.717.033-1.07.1a4.895 4.895 0 00-1 .29 4.431 4.431 0 00-.86.49c-.287.21-.561.437-.82.68l1.24 1.22a5.829 5.829 0 011-.7c.35-.201.747-.304 1.15-.3a1.91 1.91 0 011.27.38c.311.278.477.684.45 1.1a2.127 2.127 0 01-.36 1.11 7.126 7.126 0 01-1 1.25c-.44.43-.98.92-1.59 1.43-.61.51-1.41 1.06-2.16 1.65V17h8v-2h-4z" />
	</svg>
);

export const h3Icon = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<rect x="0" fill="none" width="24" height="24" />

		<path d="M14.11 14.218c.355.287.749.523 1.17.7.434.181.9.273 1.37.27.484.017.965-.086 1.4-.3a.92.92 0 00.55-.84 1.136 1.136 0 00-.15-.58 1.137 1.137 0 00-.51-.43 3.65 3.65 0 00-1-.27 9.786 9.786 0 00-1.52-.1v-1.57a4.73 4.73 0 002.17-.36 1.06 1.06 0 00.63-.93.9.9 0 00-.38-.81 2.002 2.002 0 00-1.13-.28 2.836 2.836 0 00-1.14.28 5.568 5.568 0 00-1.06.62l-1.22-1.39a6.55 6.55 0 011.64-.9 5.354 5.354 0 011.9-.33 6.448 6.448 0 011.56.17c.431.101.84.277 1.21.52.325.211.595.495.79.83.19.342.287.729.28 1.12.011.48-.177.943-.52 1.28a3.867 3.867 0 01-1.46.86v.06c.609.14 1.175.425 1.65.83.437.382.68.94.66 1.52.005.421-.113.835-.34 1.19a2.853 2.853 0 01-.9.88 4.462 4.462 0 01-1.32.55 6.395 6.395 0 01-1.57.19 6.42 6.42 0 01-2.31-.37 4.29 4.29 0 01-1.57-1l1.12-1.41zM9 11H5V7H3v10h2v-4h4v4h2V7H9v4z" />
	</svg>
);

export const h4Icon = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<rect x="0" fill="none" width="24" height="24" />

		<path d="M11 17H9v-4H5v4H3V7h2v4h4V7h2v10zm10-2h-1v2h-2v-2h-5v-2l4.05-6H20v6h1v2zm-3-2V9l-2.79 4H18z" />
	</svg>
);

export const h5Icon = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<rect x="0" fill="none" width="24" height="24" />

		<path d="M14.09 14.19c.352.269.73.5 1.13.69a3.07 3.07 0 001.34.29 2.54 2.54 0 001.44-.4 1.29 1.29 0 00.57-1.14A1.3 1.3 0 0018 12.5a2.292 2.292 0 00-1.38-.39h-.47a2.197 2.197 0 00-.4.08l-.41.15-.48.23-1.02-.57.28-5h6.4v1.92h-4.31L16 10.76a4.57 4.57 0 01.68-.18c.235-.037.472-.054.71-.05.463-.004.924.057 1.37.18.411.115.798.305 1.14.56.33.248.597.57.78.94.212.422.322.888.32 1.36.007.497-.11.989-.34 1.43a3.336 3.336 0 01-.91 1.07c-.393.3-.837.527-1.31.67a5.165 5.165 0 01-1.54.26 5.993 5.993 0 01-2.31-.39 5.427 5.427 0 01-1.59-1l1.09-1.42zM11 17H9v-4H5v4H3V7h2v4h4V7h2v10z" />
	</svg>
);

export const h6Icon = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<rect x="0" fill="none" width="24" height="24" />

		<path d="M11 17H9v-4H5v4H3V7h2v4h4V7h2v10zm8.579-7.508a3.157 3.157 0 00-.82-.49 2.683 2.683 0 00-1.94 0 1.991 1.991 0 00-.78.52c-.244.27-.431.586-.55.93a4.643 4.643 0 00-.25 1.43 4.168 4.168 0 011.25-.77c.406-.171.84-.262 1.28-.27.416-.006.83.048 1.23.16.365.118.705.304 1 .55.296.253.529.571.68.93.194.403.303.843.32 1.29.01.468-.093.931-.3 1.35a3.192 3.192 0 01-.83 1 3.63 3.63 0 01-1.2.64 4.71 4.71 0 01-3-.05 3.71 3.71 0 01-1.35-.85 4.193 4.193 0 01-1-1.48 5.809 5.809 0 01-.32-2.16 6.496 6.496 0 01.38-2.34 4.58 4.58 0 011-1.62c.407-.416.898-.74 1.44-.95a4.637 4.637 0 011.7-.31 5.192 5.192 0 012 .34c.5.19.963.464 1.37.81l-1.31 1.34zm-2.39 5.84c.203.001.406-.03.6-.09.184-.046.357-.128.51-.24.151-.136.271-.303.35-.49.093-.225.137-.467.13-.71a1.259 1.259 0 00-.43-1.07 1.806 1.806 0 00-1.12-.33 2.406 2.406 0 00-1 .21 2.913 2.913 0 00-1 .73c.047.346.144.683.29 1 .109.231.258.441.44.62.153.149.338.261.54.33.226.055.46.068.69.04z" />
	</svg>
);

export default icon;
